export default __webpack_public_path__ + "static/media/unselectcard.99e70788.mp3";